import { Field, FieldContainer, type FieldContainerProps, FinalFormCheckbox } from "@comet/admin";
import { type VividFieldProps } from "@src/components/fields/interfaces";
import { type FC, type PropsWithChildren } from "react";

import { CheckboxColorWrapper, CheckBoxSectionContainer } from "./Checkbox.sc";

interface CheckboxSection {
    label?: string;
}
export const CheckboxSection: FC<PropsWithChildren<CheckboxSection & FieldContainerProps>> = ({ children, ...props }) => (
    <CheckBoxSectionContainer>
        <FieldContainer variant="horizontal" {...props}>
            {children}
        </FieldContainer>
    </CheckBoxSectionContainer>
);

export const CheckboxField: FC<PropsWithChildren<VividFieldProps>> = (props) => (
    <CheckboxColorWrapper>
        <Field type="checkbox" component={FinalFormCheckbox} fieldContainerProps={{ variant: "horizontal" }} color="primary" {...props} />
    </CheckboxColorWrapper>
);
